/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchData, formatNumber, getTranslatedValue, toasterrormsg } from '../../../../reusable';
import { Tr } from '../../../../_metronic/i18n/Tr';
import { PageTitle } from '../../../../_metronic/layout/core';
import { useLang } from '../../../../_metronic/i18n/Metronici18n';

const ViewTourBookingDetails = () => {
    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
        if (categoryId != '5') {
            navigate('../dashboard/');
        }
    }, [categoryId])

    const location = useLocation();
    const [bookingDetails, setBookingDetails] = useState([]) as any;
    const [booking, setBooking] = useState({}) as any;
    const [userDetail, setUserDetail] = useState({}) as any;
    const [preDiscountAmount, setPreDiscountAmount] = useState('') as any
    const [discountPerncentage, setDiscountPercentage] = useState('') as any
    const [couponType, setCouponType] = useState("")
    const [couponValue, setCouponValue] = useState("")
    const bookingId = (location.state as any)?.bookingId || '';

    const formatDate = (date: any) => {
        return moment(date).format('ddd, DD MMM YYYY').toUpperCase();
    };
    // covert hours into days
    const convertHours = (totalHours: any) => {
        const duration = moment.duration(totalHours, 'hours');
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();

        return `${days} ${t('days')} ${hours} ${t('hrs')}`;
    };
    // view profile api call
    const bookingDetailsApiCall = async () => {

        var param: any = {
            bookingId: bookingId,
            categoryId: categoryId
        }

        var response: any = await fetchData("public/bookingDetail", param)
        if (response.status == "200") {
            var data = response.data
            setUserDetail(data[0]['userDetail'][0])
            setBooking(data[0])
            setBookingDetails(data[0]['bookingDetail'])
            setPreDiscountAmount(data[0].discount)
            setDiscountPercentage(data[0]['bookingDetail'][0]?.vendorDiscountPercentage)
            var couponData = data[0]['couponDetail']
            if (Object.keys(couponData).length > 0) {
                setCouponType(couponData['couponType'] ? couponData['couponType'] : '')
                setCouponValue(couponData['couponValue'])
            }
        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        bookingDetailsApiCall()
    }, [bookingId])
    return (
        <>
            <PageTitle breadcrumbs={[]}>{t('View Booking Details')}</PageTitle>
            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                <div className='card-header'>
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>{t('Booking Details')}</h3>
                    </div>
                </div>
                <div className='card-body p-9'>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('Booking ID')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>#{booking['bookingCode']}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('User Name')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{userDetail && userDetail['fullName']}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('Date Booked')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{formatDate(booking['created'])}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('User Location')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{userDetail && userDetail['location']}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('Payment Method')}</label>
                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{booking['paymentMethod'] ? booking['paymentMethod'] : ''}</span>
                        </div>
                    </div>
                </div>
            </div>
            {
                bookingDetails.map((detail: any, index: any) => {

                    var primaryLanguage = detail['actionDetail'][0]['primaryLanguage'] || '';
                    var tourPackageName = getTranslatedValue(lang, detail['actionDetail'][0], '_agencyName');                    
                    var tourPackageName1 = getTranslatedValue(lang, detail['actionTypeDetail'][0], '_name');                    
                    var departure = getTranslatedValue(lang, detail['actionTypeDetail'][0]["departureRegionDetail"][0], '_name');        
                    
                    console.log("++++", detail['actionTypeDetail'][0]["departureRegionDetail"]);
                    

                    return (
                        <div className='card mb-5 mb-xl-10' id='kt_profile_details_view' key={index}>
                            <div className='card-header'>
                                <h3 className='card-title align-items-start flex-column'>
                                    <span className='card-label fw-bolder fs-3 mb-1'>{t('Booked Tour Package')}</span>
                                </h3>
                            </div>
                            <div className='card-body p-9'>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Tour Type')}</label>

                                    <div className='col-lg-8'>
                                        {detail['actionDetail'][0]['tourTypeDetail'].map((tourTypeDetail: any, index: any) => {                                            
                                            return <div key={index} className="fw-bolder fs-6 text-dark mt-0">
                                                {getTranslatedValue(lang, tourTypeDetail, '_name', primaryLanguage)}
                                                {index !== detail['actionDetail'][0]['tourTypeDetail'].length - 1 ? ', ' : ''}
                                            </div>
                                        })}
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Tour Agency Name')}</label>

                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{tourPackageName}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Tour Name')}</label>

                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{tourPackageName1}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Departure From')}</label>

                                    <div className='col-lg-8'>
                                        {detail['actionTypeDetail'].map((actionTypeDetail: any, index: any) => {
                                            return <div key={index} className="fw-bolder fs-6 text-dark mt-0">
                                                {actionTypeDetail['departureRegionDetail'] ? getTranslatedValue(lang, actionTypeDetail['departureRegionDetail'][0], '_name', primaryLanguage) : ''}
                                                {index !== detail['actionTypeDetail'].length - 1 ? ', ' : ''}
                                            </div>
                                        })}
                                        
                                        {/* <span className='fw-bolder fs-6 text-dark'>{departure}</span> */}
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('No Of People')}</label>
                                    <div className='col-lg-8'>
                                        <label className='fw-bold text-muted'>{t('Infant:')}</label>
                                        <span className='fw-bolder fs-6 text-dark mx-3'>{detail['infant']}</span>
                                        <label className='fw-bold text-muted'>{t('Child:')}</label>
                                        <span className='fw-bolder fs-6 text-dark mx-3'>{detail['child']}</span>
                                        <label className='fw-bold text-muted'>{t('Adult:')}</label>
                                        <span className='fw-bolder fs-6 text-dark mx-3'>{detail['adult']}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Reservation Date')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{detail['fromDate'] ? formatDate(detail['fromDate']) : ''}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Total Tour Tickets')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{detail['quantity'] ? detail['quantity'] : ''}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Tour Duration')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{detail['bookingDuration'] ? convertHours(detail['bookingDuration']) : ''}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className={`card card-xl-stretch mb-0`}>
                                            {/* begin::Header */}
                                            <div className='card-header border-bottom-0 px-0'>
                                                <h3 className='card-title align-items-start flex-column'>
                                                    <span className='card-label fw-bolder fs-3 mb-1'>{t('Traveller Info')}</span>
                                                </h3>
                                            </div>
                                            {/* end::Header */}
                                            {/* begin::Body */}
                                            <div className='card-body py-0 px-0'>
                                                <div className='tab-content'>
                                                    {/* begin::Tap pane */}
                                                    <div className='tab-pane fade show active' id='kt_table_widget_4_tab_1'>
                                                        {/* begin::Table container */}
                                                        <div className='table-responsive'>
                                                            {/* begin::Table */}
                                                            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
                                                                {/* begin::Table head */}
                                                                <thead>
                                                                    <tr className='fw-bold rounded text-muted bg-light'>
                                                                        {/* <th className='p-0 w-50px'></th> */}
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Full Name')}</th>
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Traveler Age')}</th>
                                                                        <th className='min-w-150px'>{t('Id Number')}</th>
                                                                        <th className='min-w-120px rounded-end'>{t('Gender')}</th>
                                                                    </tr>
                                                                </thead>
                                                                {/* end::Table head */}
                                                                {/* begin::Table body */}
                                                                <tbody>
                                                                    {
                                                                        detail['travellerInfo'] && (

                                                                            detail['travellerInfo'].map((traveller: any, index: any) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td className='text-start ps-3'>
                                                                                            <div className='text-dark fw-bold mb-1 fs-6'>
                                                                                                {traveller['firstName'] + ' ' + traveller['lastName']}
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{traveller['age']}</span>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{traveller['idNumber']}</span>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{traveller['gender']}</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        )
                                                                    }
                                                                </tbody>
                                                                {/* end::Table body */}
                                                            </table>
                                                            {
                                                                detail['travellerInfo'].length == 0 && (
                                                                    <div className="row w-100">
                                                                        <div className="col-lg-12">
                                                                            <div className='text-gray-500 text-center fw-bold mb-1 fs-6'>{t('No Record Found.')}</div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                        {/* end::Table */}
                                                    </div>
                                                    {/* end::Tap pane */}
                                                </div>
                                            </div>
                                            {/* end::Body */}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className='card card-xl-stretch mb-0'>
                                            {/* begin::Header */}
                                            <div className='card-header border-bottom-0 px-0'>
                                                <h3 className='card-title align-items-start flex-column'>
                                                    <span className='card-label fw-bolder fs-3 mb-1'>{t('Additional Info')}</span>
                                                </h3>
                                            </div>
                                            {/* end::Header */}
                                            {/* begin::Body */}
                                            <div className='card-body py-0 px-0'>
                                                <div className='tab-content'>
                                                    {/* begin::Tap pane */}
                                                    <div className='tab-pane fade show active' id='kt_table_widget_4_tab_2'>
                                                        {/* begin::Table container */}
                                                        <div className='table-responsive'>
                                                            {/* begin::Table */}
                                                            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
                                                                {/* begin::Table head */}
                                                                <thead>
                                                                    <tr className='fw-bold rounded text-muted bg-light'>
                                                                        {/* <th className='p-0 w-50px'></th> */}
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Meeting Points')}</th>
                                                                        <th className='min-w-120px rounded-end'>{t('Tour Language')}</th>
                                                                        <th className='min-w-120px rounded-end'>{t('Phone Number')}</th>
                                                                    </tr>
                                                                </thead>
                                                                {/* end::Table head */}
                                                                {/* begin::Table body */}
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='text-start ps-3'>
                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{detail['additionalInfo']['meetingPoint']}</span>
                                                                        </td>
                                                                        <td className='text-start ps-3'>
                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{detail['additionalInfo']['tourlanguage']}</span>
                                                                        </td>
                                                                        <td className='text-start ps-3'>
                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{detail['additionalInfo']['phoneNumber']}</span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                {/* end::Table body */}
                                                            </table>
                                                        </div>
                                                        {/* end::Table */}
                                                    </div>
                                                    {/* end::Tap pane */}
                                                </div>
                                            </div>
                                            {/* end::Body */}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className='card card-xl-stretch mb-0'>
                                            {/* begin::Header */}
                                            <div className='card-header border-bottom-0 px-0'>
                                                <h3 className='card-title align-items-start flex-column'>
                                                    <span className='card-label fw-bolder fs-3 mb-1'>{t('Contact Info')}</span>
                                                </h3>
                                            </div>
                                            {/* end::Header */}
                                            {/* begin::Body */}
                                            <div className='card-body py-0 px-0'>
                                                <div className='tab-content'>
                                                    {/* begin::Tap pane */}
                                                    <div className='tab-pane fade show active' id='kt_table_widget_4_tab_3'>
                                                        {/* begin::Table container */}
                                                        <div className='table-responsive'>
                                                            {/* begin::Table */}
                                                            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
                                                                {/* begin::Table head */}
                                                                <thead>
                                                                    <tr className='fw-bold rounded text-muted bg-light'>
                                                                        {/* <th className='p-0 w-50px'></th> */}
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Name')}</th>
                                                                        <th className='min-w-150px'>{t('Surname')}</th>
                                                                        <th className='min-w-120px rounded-end'>{t('Contact Number')}</th>
                                                                        <th className='min-w-120px rounded-end'>{t('Email')}</th>
                                                                    </tr>
                                                                </thead>
                                                                {/* end::Table head */}
                                                                {/* begin::Table body */}
                                                                <tbody>
                                                                    {
                                                                        detail['guestInfo'] && (

                                                                            detail['guestInfo'].map((contact: any, index: any) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{contact['name']}</span>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{contact['surname']}</span>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{contact['contactNumber']}</span>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{contact['email']}</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        )
                                                                    }
                                                                </tbody>
                                                                {/* end::Table body */}
                                                            </table>
                                                            {
                                                                detail['guestInfo'].length == 0 && (
                                                                    <div className="row w-100">
                                                                        <div className="col-lg-12">
                                                                            <div className='text-gray-500 text-center fw-bold mb-1 fs-6'>{t('No Record Found.')}</div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                        {/* end::Table */}
                                                    </div>
                                                    {/* end::Tap pane */}
                                                </div>
                                            </div>
                                            {/* end::Body */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <div className="row">
                <div className="col-lg-6">
                    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                        <div className='card-header'>
                            <div className='card-title m-0'>
                                <h3 className='fw-bolder m-0'>{t('Payment Details')}</h3>
                            </div>
                            <div className='card-title m-0'>
                                {
                                    booking['status'] == 2 && (
                                        <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Rejected')}</span>
                                    )
                                }
                                {
                                    booking['status'] == 3 && (
                                        <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Cancelled')}</span>
                                    )
                                }
                            </div>
                        </div>
                        <div className='card-body p-9'>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Original Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['subTotal']))} UZS</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Extra Charge')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['extraCharge']))} UZS</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('User Points')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['pointAmount']))} UZS</span>
                                    <span className='fw-bold fs-7'> ({booking['point'] + ` ${t('points')}`})</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Coupon Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>
                                        {booking['couponDiscount'] == '' || booking['couponDiscount'] == undefined || booking['couponDiscount'] == null
                                            ? 0
                                            : formatNumber(parseFloat(booking['couponDiscount']))}{' '}
                                    </span>
                                    {/* {/ <span className='fw-bold fs-7'> (10% OFF coupon OR 15,000 UZS coupon)</span> /} */}
                                    <span className='fw-bolder fs-7 text-dark'>
                                        {' '}
                                        ({couponValue} {" "}
                                        {couponType == 'FIXED'
                                            ? t('UZS Coupon')
                                            : couponType == 'PERCENTAGE'
                                                ? t('% OFF coupon')
                                                : t('No Coupon Applied')}
                                        )
                                    </span>{' '}
                                </div>
                            </div>
                            <div className='row mb-7 pb-5 border-bottom border-gray-300'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Discount Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>
                                        {preDiscountAmount == '' ? 0 : formatNumber(parseFloat(booking['discount']))}{' UZS'}
                                    </span>
                                    <span className='fw-bolder fs-7 text-dark'>
                                        {' '}
                                        (
                                        {bookingDetails[0] != undefined &&
                                            bookingDetails[0] != null &&
                                            bookingDetails[0] != '' &&
                                            bookingDetails[0].specialDiscount == 0
                                            ? discountPerncentage != ''
                                                ? discountPerncentage.toFixed(2) + ` % ${t('discount')}`
                                                : `0 % ${t('discount')}`
                                            : `${t('Special Discount')}`}
                                        )
                                    </span>{' '}
                                </div>
                            </div>
                            {
                                (booking['status'] == 2 || booking['status'] == 3) && (
                                    <>
                                        <div className='row py-3 border-bottom border-gray-300'>
                                            <label className='col-lg-4 fw-bold'>{t('Total Paid')}</label>
                                            <div className='col-lg-8'>
                                                <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['totalPaid']))} UZS</span>
                                            </div>
                                        </div>
                                        <div className='row py-3 border-bottom border-gray-300 text-danger'>
                                            <label className='col-lg-4 fw-bold'>{booking['status'] == 2 ? `${t('Refundable')}` : `${t('Cancellation')}`} {t('Amount')}</label>
                                            <div className='col-lg-8'>
                                                <span className='fw-bolder fs-6'>- {formatNumber(parseFloat(booking['bookingDetail'][0]['cancellationAmount'] || 0))} UZS</span>
                                                <span className='fw-bold fs-7'> ({(booking['bookingDetail'][0]['cancellationCharge']).toFixed(2)}% {t('refund')})</span>
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                            <div className='row my-7'>
                                <label className='col-lg-4 fw-bold fs-6'>{t('Final Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['totalAmount']))} UZS</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                        <div className='card-header'>
                            <div className='card-title m-0'>
                                <h3 className='fw-bolder m-0'>{t('Insayr Commission')}</h3>
                            </div>
                        </div>
                        <div className='card-body p-9'>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('INSAYR Service Fee')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{booking['insayrServiceRate'] ? parseFloat(booking['insayrServiceRate']).toFixed(2) : '0.00'}%</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('INSAYR Service Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{booking['insayrServiceFee'] ? formatNumber(parseFloat(booking['insayrServiceFee'])) : '0'} UZS</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { ViewTourBookingDetails }